import { Injectable } from '@angular/core';

/** Plataforma detectada, para dar el paso a paso de instalacion que corresponde. */
export type Plataforma = 'ios' | 'android' | 'escritorio';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor() {}

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }

  /**
   * iOS incluye iPad.
   *
   * Desde iPadOS 13 el iPad se anuncia como "Macintosh" para recibir sitios
   * de escritorio, asi que por user agent solo es indistinguible de una Mac:
   * lo que lo delata es que tenga pantalla tactil (`maxTouchPoints > 1`).
   * Importa porque en iOS no existe el instalador automatico y el paso a
   * paso es distinto (Compartir -> Agregar a inicio).
   */
  isIos(): boolean {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return true;
    return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  }

  isAndroid(): boolean {
    return /Android/.test(navigator.userAgent);
  }

  plataforma(): Plataforma {
    if (this.isIos()) return 'ios';
    if (this.isAndroid()) return 'android';
    return 'escritorio';
  }

  /** ¿Ya se esta ejecutando como app instalada y no en una pestana del navegador? */
  estaInstalada(): boolean {
    const standaloneIos = (window.navigator as unknown as { standalone?: boolean }).standalone;
    return window.matchMedia?.('(display-mode: standalone)').matches || standaloneIos === true;
  }
}
